import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import React, { FC, useState } from 'react';
import LocalModal from 'components/base/local-modal';
import LocalTextArea from 'components/base/local-text-area';
import useOrdersContext from 'contexts/orders.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { handleApiError } from 'utils/functions';

type DiscountCodeModalProps = {
  show: boolean;
  onClose: () => void;
};

const DiscountCodeModal: FC<DiscountCodeModalProps> = ({ show, onClose }) => {
  const { calculatedOrderForm, setcalculatedOrderForm } = useOrdersContext();
  const [code, setCode] = useState(calculatedOrderForm.discount_code);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    onClose();
  };

  const confirmDiscount = async () => {
    const data = {
      discount_code: code,
      meals: calculatedOrderForm.meals
    };
    try {
      setLoading(true);
      const res = await apiService.post('deal/verify', {
        data,
        baseURL: process.env.REACT_APP_CORE_API_URL
      });
      if (res.data) {
        setcalculatedOrderForm({
          ...calculatedOrderForm,
          discount_code: code
        });
        toast(<ToastMessage message='Discount code applied' type='success' />);
      }
    } catch (error) {
      handleApiError(error, 'Failed to add discount code');
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={handleClose}
      title='Add discount Code'
      contentClassName=' sm:!max-w-[400px]'>
      <div>
        <div>
          <div className='text-sm font-medium flex gap-1 mt-5 mb-2'>
            <p className='text-[#2E3031]'>Enter code</p>
          </div>
          <LocalTextArea
            placeholder='Discount Code'
            className='text-sm bg-[#FAFAFA] border-x-0 border-t-0 rounded-none h-[25px]'
            value={code}
            onChange={(e) => setCode(e.target.value)}
            autoFocus
          />
        </div>
        <div className='mt-5 flex justify-end'>
          <Button
            color='primary'
            variant='block'
            className='w-[139px] h-[41px]'
            loading={loading}
            onClick={() => {
              if (code === '') {
                setcalculatedOrderForm({
                  ...calculatedOrderForm,
                  discount_code: code
                });
                onClose();
              } else {
                confirmDiscount();
              }
            }}>
            Confirm
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default DiscountCodeModal;
